const Mock = require('mockjs');
const count = 100


const List = [{
    id: 0,
    isTop: true,
    banner: require('../assets/QQ图片20210113164224.jpg'),
    isHot: true,
    pubTime: +Mock.Random.date('T'),
    title: '游戏王（YGO）GX版~遗老卡池',
    summary: '游戏王（YGO）GX版~遗老卡池',
    content: '',
    viewsCount: '500',
    commentsCount: '0'
}]


export default [
    {
        url: '/post/list',
        type: 'get',
        response: config => {
            console.log(List)
            let {page = 1, size = 10} = config.query;
            page = page instanceof Number ? page : parseInt(page)
            size = size instanceof Number ? size : parseInt(size)
            const pageList = List.filter((item, index) => index < size * page && index >= size * (page - 1));
            return {
                code: 20000,
                data: {
                    total:List.length,
                    items:pageList.sort((a,b)=>a.isTop===b.isTop?0:a.isTop?-1:1),
                    hasNextPage: page * size < List.length,
                    page: page,
                    size: size
                }
            }
        }
    }
]
